<div id="steps" class="container">
  <div class="row small-font">
    @for (step of stepsModels(); track step) {
      <div class="step-element">
        <span>
          @if (style()?.leadingColorCode) {
            <div [style.background-color]="step.active ? style().leadingColorCode : 'grey'" class="ordinal-number">
              {{ $index + 1 }}.
            </div>
          } @else {
            <div [ngClass]="{ active: step.active }" class="ordinal-number">{{ $index + 1 }}.</div>
          }
        </span>
        <span [class.disabled-text]="!step.active">{{ step.text }}</span>
      </div>
    }
  </div>
</div>
